module.exports = __webpack_public_path__ + "img/dfn_qrcode.55c675c9.jpg";